export const btnRegExp = /<button[^>]*>.*?<\/button>/gi;
